<template>
  <div class="page-wrap">
    <!-- 顶部导航栏 -->
    <div
      ref="nav"
      class="nav">
      <div class="nav-left">
        <div
          class="logo"
          @click="toPage('/myHome')">
          <img
            src="@/assets/logo.png"
            alt="" />
        </div>
      </div>
      <div
        class="nav-right"
        v-show="!searchShow">
        <div class="search icon">
          <img
            @click="openSearch"
            src="@/assets/icon/search.png"
            alt="" />
        </div>
        <div
          @click="clickMoreShow"
          class="more icon">
          <img
            v-show="!moreShow"
            src="@/assets/icon/more.png"
            alt="" />
          <img
            v-show="moreShow"
            src="@/assets/icon/close.png"
            alt="" />
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <div :class="{ 'more-slider': true, 'more-slider--show': moreShow }">
      <!-- 导航菜单 -->
      <nav-bar-menu
        v-show="!searchShow"
        @close="moreShow = false" />
      <div
        class="searchBox"
        v-show="searchShow">
        <van-field
          v-model="inputSelectVal"
          center
          placeholder="请输入关键词">
          <template #button>
            <span
              @click="goSearchIndex"
              class="iconfont icon-sousuo"></span>
          </template>
        </van-field>
        <div
          class="iconfont icon-close"
          @click="closeSearch"></div>
      </div>
    </div>
    <!-- 内容容器 -->
    <div class="main">
      <slot></slot>
    </div>
    <!-- 底部导航栏 -->
    <n-flooter />
  </div>
</template>

<script>
import { toPage } from '@/utils/tool';
import NavBarMenu from './NavBarMenu.vue';
import NFlooter from './NFlooter.vue';
export default {
  components: { NavBarMenu, NFlooter },
  data() {
    return {
      moreShow: false,
      searchShow: false,
      inputSelectVal: '',
      toPage,
    };
  },
  created() {
    this.$bus.$on('menuClose', () => {
      this.moreShow = false;
    });
  },
  beforeDestroy() {
    this.$off();
  },
  methods: {
    // 菜单打开关闭
    clickMoreShow() {
      this.moreShow = !this.moreShow;
    },
    // 打开搜索
    openSearch() {
      (this.searchShow = true), (this.moreShow = true);
    },
    // 打开搜索
    closeSearch() {
      (this.searchShow = false), (this.moreShow = false);
    },
    goSearchIndex() {
      if (!this.inputSelectVal) return this.$toast('请输入关键词');
      this.$router.push({
        name: 'globalSearch',
        params: { info: this.inputSelectVal },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
/* phone */
@media (max-width: $phone-max-size) {
  .page-wrap {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    // justify-content: space-between;
    overflow-x: hidden;

    .nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      padding: 9px 20px;
      z-index: 99;
      background: linear-gradient(
        180deg,
        #003365 0%,
        rgba(0, 51, 101, 0.5) 100%
      );

      &-left {
        .logo {
          width: 80px;

          img {
            width: 100%;
          }
        }
      }

      &-right {
        display: flex;

        .search {
          margin-right: 10px;
        }

        .icon {
          width: 24px;

          img {
            width: 100%;
          }
        }
      }
    }

    .more-slider {
      width: 100%;
      height: calc(100vh - 44px);
      overflow-y: scroll;
      position: fixed;
      left: 0;
      top: 44px;
      background: rgba(0, 51, 101, 0.5);
      backdrop-filter: blur(10px);
      transform: translateX(100%);
      transition: transform 0.5s;
      // touch-action: pan-x pan-y pinch-zoom;
      z-index: 999;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .searchBox {
      width: 335px;
      margin: 13px auto;
      display: flex;
      align-items: center;
      ::v-deep .van-cell {
        background: none;
        border: 1px solid rgba($color: #f2f2f2, $alpha: 0.6);
        padding: 5px 10px;
        .van-field__control {
          color: #ffffff;
        }
        &::after {
          border: none;
        }
      }
      .iconfont {
        color: #ffffff;
      }
      .icon-close {
        color: rgba($color: #f2f2f2, $alpha: 0.6);
        margin-left: 10px;
        font-size: 25px;
      }
    }
    .no-swipe {
      touch-action: pan-x pan-y;
      overflow: hidden;
    }

    .more-slider--show {
      transform: translateX(0) !important;
    }
  }
}
/* ipad */
@media (min-width: $ipad-min-size) and (max-width: $ipad-max-size) {
  .page-wrap {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    // justify-content: space-between;
    overflow-x: hidden;

    .nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      padding: 9px 20px;
      z-index: 99;
      background: linear-gradient(
        180deg,
        #003365 0%,
        rgba(0, 51, 101, 0.5) 100%
      );

      &-left {
        .logo {
          width: 80px;

          img {
            width: 100%;
          }
        }
      }

      &-right {
        display: flex;

        .search {
          margin-right: 10px;
        }

        .icon {
          width: 24px;

          img {
            width: 100%;
          }
        }
      }
    }

    .more-slider {
      width: 100%;
      height: calc(100vh - 44px);
      overflow-y: scroll;
      position: fixed;
      left: 0;
      top: 44px;
      background: rgba(0, 51, 101, 0.5);
      backdrop-filter: blur(10px);
      transform: translateX(100%);
      transition: transform 0.5s;
      // touch-action: pan-x pan-y pinch-zoom;
      z-index: 999;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .searchBox {
      width: 600px;
      margin: 13px auto;
      display: flex;
      align-items: center;
      ::v-deep .van-cell {
        background: none;
        border: 1px solid rgba($color: #f2f2f2, $alpha: 0.6);
        padding: 5px 10px;
        .van-field__control {
          color: #ffffff;
        }
        &::after {
          border: none;
        }
      }
      .iconfont {
        color: #ffffff;
      }
      .icon-close {
        color: rgba($color: #f2f2f2, $alpha: 0.6);
        margin-left: 10px;
        font-size: 25px;
      }
    }
    .no-swipe {
      touch-action: pan-x pan-y;
      overflow: hidden;
    }

    .more-slider--show {
      transform: translateX(0) !important;
    }
  }
}
</style>
